"use strict";

/**
 * Esegue la callback (cb) al DOM ready e ai ripristini da bfcache.
 */
function onReady(cb) {
    const runWhenSiteReady = () => {
        const loader = document.getElementById('siteLoader');
        const isReady = window.__siteReady || !loader || !loader.classList.contains('is-visible');
        if (isReady) {
            cb();
            return;
        }
        const handler = () => cb();
        window.addEventListener('site:ready', handler, { once: true });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runWhenSiteReady, { once: true });
    } else {
        runWhenSiteReady();
    }
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            runWhenSiteReady();
        }
    });
}
export { onReady };
